import { msalInstance } from "@/main.tsx"

export const hasRole = (role: string) => {
  const account = msalInstance.getActiveAccount()
  const roles = account?.idTokenClaims?.roles || []

  // Check for specific role or superuser role
  return roles.includes(role) || roles.includes("Full.Dashboard.Admin")
}
